import React from 'react'
import { ThreeDots } from 'react-loader-spinner'
const IMSContentLoader = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
            }}
        >
            <ThreeDots
                visible={true}
                height="80"
                width="80"
                color="#4f2682"
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
            />
        </div>
    )
}
export default IMSContentLoader
